import { chipClasses } from "@mui/material"
import { blueGrey } from "../../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ deleted: boolean }>()(
  ({ spacing }, { deleted }) => ({
    optionContainer: {
      padding: spacing(2, 4),
      cursor: "pointer",

      "&:not(:last-child)": {
        borderBottom: `1px solid ${blueGrey[100]}`
      },

      "&:hover, &.Mui-focused": {
        backgroundColor: blueGrey[50],

        [`& .${chipClasses.root}`]: {
          backgroundColor: blueGrey[100]
        }
      },

      [`& .${chipClasses.root}`]: {
        transition: "none"
      }
    },
    orgName: {
      color: blueGrey[500],

      fontStyle: deleted ? "italic" : "normal"
    }
  })
)
